<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-select v-model="listQuery.exam_id" clearable placeholder="请选择" @change="getData">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生:">
          <el-input v-model="listQuery.message" clearable placeholder="输入姓名或身份证号"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="student_name" label="姓名">
      </el-table-column>
      <el-table-column prop="student_code" label="学号">
      </el-table-column>
      <el-table-column prop="exam_name" label="考试名称">
      </el-table-column>
      <el-table-column prop="station_total" label="考站数">
      </el-table-column>
      <el-table-column prop="score_total" label="总成绩">
      </el-table-column>
      <el-table-column prop="ranking" label="排名">
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <i class="el-icon-search" @click="goDetail(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page"
                  @pagination="getData"/>

    </div>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                student: {},
                examList: [],
                total: 0,
                dialogType: 'new',
                dialogVisible: false,
                listQuery: {
                    page: 1,
                    per_page: 20,
                },
                tableData: []
            };
        },
        computed: {},
        created() {
            this.getData();
        },
        methods: {
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            getData() {
                this.$http.getStudentScore(this.listQuery)
                    .then(res => {
                        this.tableData = res.data;
                        this.examList = res.examDownlist;
                        this.total = res.meta.total;
                        this.listQuery.exam_id = res.exam_id;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            goDetail(row) {
                this.$router.push({
                    name: 'studentScoreDetail', query: {
                        student_id: row.student_id,
                    }
                });
            }
        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/studentScores.vue